module.exports = __webpack_public_path__ + "media/images/flags/1x1/fji-8154fe8ef53322a860ff00d6b5cc284b.svg";